/* eslint-disable import/no-internal-modules */
import { CartIconButtonV3 } from "user_site/features/cart";
import { WithProviders } from "user_site/utils";

const Component = () => (
  <WithProviders>
    <CartIconButtonV3 />
  </WithProviders>
);

export default Component;
